import { Tag } from "antd";
import { IDocumentDownloadSigningStatus } from "../../../../../interfaces/Ui/Documents/DocumentsDownload/IDocumentDownloadSigningStatus";
import React from "react";
import { DOCUMENT_DOWNLOAD_SIGNIN_STATUS_ENUM } from "../../../../../enums/documentDownloadSigningStatusEnum";

export const SigningStatusDocument = ({
  children,
  status = DOCUMENT_DOWNLOAD_SIGNIN_STATUS_ENUM.SIGNED,
}: IDocumentDownloadSigningStatus) => {
  if (status === DOCUMENT_DOWNLOAD_SIGNIN_STATUS_ENUM.SIGNED) {
    const signedText = children ? children : "Подписано клиентом";
    return <Tag color={"green"}>{signedText}</Tag>;
  } else {
    const notSignedText = children ? children : "Без подписи";
    return <Tag color={"red"}>{notSignedText}</Tag>;
  }
};
